import { render, staticRenderFns } from "./AlertSettingAdd.vue?vue&type=template&id=5afd93bf&scoped=true"
import script from "./AlertSettingAdd.vue?vue&type=script&lang=js"
export * from "./AlertSettingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd93bf",
  null
  
)

export default component.exports